/**
 * Top Bar Slider
 * Handles auto-rotation and manual navigation for top bar USP messages
 */

if (typeof TopBarSlider !== 'function') {
  class TopBarSlider {
    constructor(container) {
      this.container = container;
      this.items = container.querySelectorAll('.topbar-slider__item');
      this.prevBtn = container.querySelector('.topbar-slider__nav--prev');
      this.nextBtn = container.querySelector('.topbar-slider__nav--next');
      this.currentIndex = 0;
      this.autoRotateInterval = parseInt(container.dataset.autoRotate) || 0;
      this.autoRotateTimer = null;
      this.isPaused = false;

      if (this.items.length > 0) {
        this.init();
      }
    }

    init() {
      // Hide navigation buttons if only one item
      if (this.items.length <= 1) {
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        return;
      }

      // Event listeners for manual navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Keyboard navigation
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.prev();
        } else if (e.key === 'ArrowRight') {
          this.next();
        }
      });

      // Pause on hover
      this.container.addEventListener('mouseenter', () => {
        this.pauseAutoRotate();
      });

      this.container.addEventListener('mouseleave', () => {
        this.resumeAutoRotate();
      });

      // Start auto-rotation if enabled
      if (this.autoRotateInterval > 0) {
        this.startAutoRotate();
      }

      // Accessibility
      this.items.forEach((item, index) => {
        item.setAttribute('role', 'listitem');
        item.setAttribute('aria-hidden', index !== 0 ? 'true' : 'false');
      });
    }

    showSlide(index) {
      if (index === this.currentIndex) return;
      const prevIndex = this.currentIndex;
      const prevItem = this.items[prevIndex];
      const nextItem = this.items[index];


      // Remove slide classes from all items
      this.items.forEach((item) => {
        item.classList.remove('topbar-slider__item--slide-in', 'topbar-slider__item--slide-out');
      });

      // Slide out previous (upwards)
      if (prevItem) {
        prevItem.classList.remove('topbar-slider__item--active');
        prevItem.classList.add('topbar-slider__item--slide-out');
        prevItem.setAttribute('aria-hidden', 'true');
      }

      // Slide in next (from below)
      if (nextItem) {
        nextItem.classList.add('topbar-slider__item--active', 'topbar-slider__item--slide-in');
        nextItem.setAttribute('aria-hidden', 'false');
      }

      // Remove slide classes after animation
      setTimeout(() => {
        if (prevItem) prevItem.classList.remove('topbar-slider__item--slide-out');
        if (nextItem) nextItem.classList.remove('topbar-slider__item--slide-in');
      }, 800);

      this.currentIndex = index;
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      this.showSlide(nextIndex);
      this.resetAutoRotate();
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.showSlide(prevIndex);
      this.resetAutoRotate();
    }

    startAutoRotate() {
      if (this.autoRotateInterval > 0 && !this.isPaused) {
        this.autoRotateTimer = setInterval(() => {
          this.next();
        }, this.autoRotateInterval * 1000);
      }
    }

    stopAutoRotate() {
      if (this.autoRotateTimer) {
        clearInterval(this.autoRotateTimer);
        this.autoRotateTimer = null;
      }
    }

    resetAutoRotate() {
      this.stopAutoRotate();
      if (!this.isPaused) {
        this.startAutoRotate();
      }
    }

    pauseAutoRotate() {
      this.isPaused = true;
      this.stopAutoRotate();
    }

    resumeAutoRotate() {
      this.isPaused = false;
      this.startAutoRotate();
    }
  }

  // Initialize all top bar sliders on the page
  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.topbar-slider');
    sliders.forEach((slider) => {
      new TopBarSlider(slider);
    });
  });

  // Re-initialize after Shopify section updates
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const slider = event.target.querySelector('.topbar-slider');
      if (slider) {
        new TopBarSlider(slider);
      }
    });
  }
}
